export const titleize = ([letter, ...letters]) =>
  `${letter.toLocaleUpperCase()}${letters.join('')}`;

export const humanize = words => words.split('_').map(titleize).join(' ');
